<template>
  <div class="m-card-primary m-the-modal-content m-the-modal-content-wide m-the-modal-content-download-pdfs">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="requestZip"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <section class="m-the-modal-section-height-auto">
        <p>{{ $t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.description') }}</p>
        <small class="text-color-black-35">
          {{ $t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.filtersDisclaimer') }}
        </small>
        <br />
        <small class="text-color-black-35">
          {{ $t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.noInvoicesDisclaimer') }}
        </small>
        <br />
        <br />

        <div class="m-download-pdfs-dates">
          <div class="m-download-pdfs-date">
            <p class="text-color-black-35 font-weight-bold margin-bottom-xsmall">
              {{ $t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.dateFrom') }}
            </p>
            <AtomDatePicker
              v-model="form.fecha_desde"
              input-class="width-100-pr"
              name="fecha_desde"
              :placeholder="$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.placeholderDateFrom')"
              wrapper-class="a-input-wrapper-column margin-bottom-small"
            />
          </div>
          <div class="m-download-pdfs-date">
            <p class="text-color-black-35 font-weight-bold margin-bottom-xsmall">
              {{ $t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.dateTo') }}
            </p>
            <AtomDatePicker
              v-model="form.fecha_hasta"
              :disabled-dates="disabledDatesHasta"
              input-class="width-100-pr"
              name="fecha_hasta"
              :placeholder="$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.placeholderDateTo')"
              wrapper-class="a-input-wrapper-column margin-bottom-small"
            />
          </div>
        </div>

        <small
          v-if="errorMessage"
          class="text-color-danger font-weight-bold"
        >
          {{ errorMessage }}
        </small>

        <small
          v-if="successMessage"
          class="text-color-success font-weight-bold"
        >
          {{ successMessage }}
        </small>
      </section>

      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          v-if="!successMessage"
          :cancel-text="$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.buttonCancel')"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMySalesInvoicesHistoryModalDownloadPdfs',

  data () {
    return {
      errorMessage: null,
      successMessage: null,
      suspendSync: false,
      disabledDatesHasta: {
        to: ''
      },
      form: {
        fecha_desde: '',
        fecha_hasta: ''
      },
      buttonPrimary: {
        action: this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  watch: {
    'form.fecha_desde' () {
      if (this.form && this.form.fecha_desde && this.form.fecha_hasta) {
        const desde = this.$moment(this.form.fecha_desde, 'YYYY-MM-DD', true)
        const hasta = this.$moment(this.form.fecha_hasta, 'YYYY-MM-DD', true)
        if (desde.isValid() && hasta.isValid() && desde.isAfter(hasta)) {
          this.form.fecha_hasta = ''
        }
      }

      if (!this.suspendSync && this.filterRef) {
        this.filterRef.fecha_desde = this.form.fecha_desde
        this.filterRef.pagina = 1
      }
      if (!this.suspendSync && this.simpleFilterRef) {
        this.simpleFilterRef.periodo = ''
      }

      this.syncDisabledDatesHasta()
      this.validateDates()
    },

    'form.fecha_hasta' () {
      if (!this.suspendSync && this.filterRef) {
        this.filterRef.fecha_hasta = this.form.fecha_hasta
        this.filterRef.pagina = 1
      }
      if (!this.suspendSync && this.simpleFilterRef) {
        this.simpleFilterRef.periodo = ''
      }
      this.validateDates()
    }
  },

  computed: {
    academiaId () {
      return this.$modal && this.$modal.element ? this.$modal.element.academiaId : null
    },

    filterRef () {
      return this.$modal && this.$modal.element ? (this.$modal.element.filterRef || null) : null
    },

    simpleFilterRef () {
      return this.$modal && this.$modal.element ? (this.$modal.element.simpleFilterRef || null) : null
    },
  },

  created () {
    this.form.fecha_desde = this.filterRef && this.filterRef.fecha_desde ? this.filterRef.fecha_desde : ''
    this.form.fecha_hasta = this.filterRef && this.filterRef.fecha_hasta ? this.filterRef.fecha_hasta : ''
    this.syncDisabledDatesHasta()
    this.validateDates()
  },

  mounted () {
    // Fuerza la carga inicial del datepicker (AtomDatePicker no corre su watch en el primer render).
    const desde = this.filterRef && this.filterRef.fecha_desde ? this.filterRef.fecha_desde : ''
    const hasta = this.filterRef && this.filterRef.fecha_hasta ? this.filterRef.fecha_hasta : ''
    if (desde || hasta) {
      this.suspendSync = true
      this.form.fecha_desde = desde
      this.form.fecha_hasta = hasta
      this.syncDisabledDatesHasta()
      this.validateDates()
      this.$nextTick(() => {
        this.suspendSync = false
      })
    }
  },

  methods: {
    syncDisabledDatesHasta () {
      this.disabledDatesHasta = {
        to: this.form && this.form.fecha_desde ? this.form.fecha_desde : ''
      }
    },

    validateDates () {
      this.errorMessage = null

      const desdeRaw = this.form ? this.form.fecha_desde : null
      const hastaRaw = this.form ? this.form.fecha_hasta : null

      if (!desdeRaw || !hastaRaw) {
        this.errorMessage = this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.errorRequiredDates')
        return false
      }

      const desde = this.$moment(desdeRaw, 'YYYY-MM-DD', true).startOf('day')
      const hasta = this.$moment(hastaRaw, 'YYYY-MM-DD', true).startOf('day')

      if (!desde.isValid() || !hasta.isValid()) {
        this.errorMessage = this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.errorInvalidDates')
        return false
      }

      if (hasta.isBefore(desde)) {
        this.errorMessage = this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.errorDesdeAfterHasta')
        return false
      }

      // Inclusivo: (hasta - desde) + 1
      const diffDays = hasta.diff(desde, 'days')
      const inclusiveDays = diffDays + 1
      if (inclusiveDays > 32) {
        this.errorMessage = this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.errorMaxRange')
        return false
      }

      return true
    },

    requestZip () {
      if (this.buttonPrimary.sending) {
        return
      }

      const isRetry = !!this.successMessage
      this.successMessage = null
      this.errorMessage = null
      if (isRetry) {
        this.buttonPrimary.action = this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.buttonPrimary')
      }

      if (!this.validateDates()) {
        return
      }

      // Garantiza que las fechas elegidas impacten en el filtro del listado.
      if (this.filterRef) {
        this.filterRef.fecha_desde = this.form.fecha_desde
        this.filterRef.fecha_hasta = this.form.fecha_hasta
        this.filterRef.pagina = 1
      }

      this.buttonPrimary.sending = true
      const baseFilter = this.filterRef ? Object.assign({}, this.filterRef) : {}
      const zipFilter = Object.assign({}, baseFilter, {
        fecha_desde: this.form.fecha_desde,
        fecha_hasta: this.form.fecha_hasta
      })
      delete zipFilter.pagina
      delete zipFilter.limite

      this.$services.read('comprobante', 'solicitarZip', {}, [this.academiaId], zipFilter)
        .then(response => {
          const backendMessage = response && response.data && typeof response.data.message === 'string'
            ? response.data.message
            : null
          this.successMessage = backendMessage || this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.success')
          this.buttonPrimary.sending = false
          this.buttonPrimary.action = this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.buttonPrimaryAgain')
        })
        .catch(error => {
          console.log(error)
          const data = error && error.response ? error.response.data : null
          this.errorMessage = (data && typeof data.message === 'string')
            ? data.message
            : this.$t('mEditionBillingMySalesInvoicesHistoryModalDownloadPdfs.errorGeneric')
          this.buttonPrimary.sending = false
        })
    }
  }
}
</script>

